import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { BsCheck } from 'react-icons/bs';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { themeColors, useStateContext } from '../contexts/ContextProvider';

const ThemeSettings = () => {
  const { setColor, setMode, currentMode, currentColor, setThemeSettings } = useStateContext();
  return (
    <div className="bg-half-transparent w-screen fixed nav-item top-0 right-0" style={{ zIndex: 4000 }}>
      <div className="float-right h-screen bg-white dark:bg-[#1B2C3A] dark:text-gray-100 w-400 shadow-2xl">
        <div className="flex justify-between items-center p-4 ml-4">
          <p className="font-semibold text-lg text-[#0B2545] dark:text-white">Settings</p>
          <button type="button" onClick={() => setThemeSettings(false)} className="text-2xl p-3 text-[#5C6B73]" aria-label="Close settings">
            <MdOutlineCancel />
          </button>
        </div>
        <div className="flex-col border-t-1 border-color p-4 ml-4">
          <p className="font-semibold text-xl">Theme option</p>
          <div className="mt-4">
            <label htmlFor="light" className="cursor-pointer">
              <input type="radio" id="light" name="theme" value="Light" onChange={setMode} checked={currentMode === 'Light'} />
              <span className="ml-2">Light</span>
            </label>
          </div>
          <div className="mt-2">
            <label htmlFor="dark" className="cursor-pointer">
              <input type="radio" id="dark" name="theme" value="Dark" onChange={setMode} checked={currentMode === 'Dark'} />
              <span className="ml-2">Dark</span>
            </label>
          </div>
        </div>
        <div className="p-4 border-t-1 border-color ml-4">
          <p className="font-semibold text-xl">Accent</p>
          <div className="flex gap-3">
            {themeColors.map((item) => (
              <TooltipComponent key={item.name} content={item.name} position="TopCenter">
                <button
                  type="button"
                  className="h-10 w-10 rounded-full"
                  style={{ backgroundColor: item.color }}
                  onClick={() => setColor(item.color)}
                  aria-label={item.name}
                >
                  <BsCheck className={`ml-2 text-2xl text-white ${item.color === currentColor ? 'inline' : 'hidden'}`} />
                </button>
              </TooltipComponent>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeSettings;
